import { render, staticRenderFns } from "./BuddyBotToken.vue?vue&type=template&id=151caa44&scoped=true"
import script from "./BuddyBotToken.vue?vue&type=script&lang=js"
export * from "./BuddyBotToken.vue?vue&type=script&lang=js"
import style0 from "./BuddyBotToken.vue?vue&type=style&index=0&id=151caa44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151caa44",
  null
  
)

export default component.exports